import { type FC, type ReactNode } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import AmModalLegalConsent from '@/components/organisms/Modals/AmModalLegalConsent'
import { useLegalConsent } from '@/contexts/legalConsent'
import { userAuthenticated, userRoles } from '@/redux/auth/selectors'
import { editUserSettingsRequest } from '@/redux/user/actions'
import { LegalConsentValues, UserRole } from '@/types'

interface Props {
  children: ReactNode
  enabledRoles: UserRole[]
}

const AmPrivateRoute: FC<Props> = ({ children, enabledRoles = [] }) => {
  const roles = useSelector(userRoles)
  const isAuthenticated = useSelector(userAuthenticated)

  const dispatch = useDispatch()

  const allowedRole = roles.some(r => enabledRoles.includes(r))

  const { showLegalConsent } = useLegalConsent()

  function changeValues ({
    termAndConditionsAccepted,
    privacyPolicyAccepted
  }: LegalConsentValues) {
    dispatch(
      editUserSettingsRequest({
        settingsToEdit: {
          termAndConditionsAccepted,
          privacyPolicyAccepted
        }
      })
    )
  }

  if (!isAuthenticated) return <Navigate to='/login' />

  if (isAuthenticated && roles.length === 0) {
    console.error('Error - User roles not present')

    return <></>
  }

  if (!allowedRole) return <Navigate to='/' />

  if (showLegalConsent) {
    return <AmModalLegalConsent changeValues={changeValues} />
  }

  return <>{children}</>
}

export default AmPrivateRoute
